<template>
  <div class="destination-advice-body">
    <div>
      <p v-if="getTerritory() === 'UK'">
        It is strongly recommended you read the travel advice pages of the
        <a :href="governmentAdviceUrl" target="_blank" rel="noopener noreferrer">
          Foreign, Commonwealth & Development Office of the UK Government
          (FCDO)
        </a>. As well as general travel advice, these pages contain a wealth of
        information relevant to visiting specific destinations. This includes
        anything that may impact on your experience whilst visiting.
      </p>
      <p v-if="getTerritory() === 'IE'">
        It is strongly recommended you read the travel advice pages of the
        <a :href="governmentAdviceUrl" target="_blank" rel="noopener noreferrer">
          Department of Foreign Affairs of the Irish Government (DFA)
        </a>. As well as general travel advice, these pages contain a wealth of
        information relevant to visiting specific destinations. This includes
        anything that may impact on your experience whilst visiting.
      </p>
      <p>
        Other passport holders should refer to their own national travel advice.
      </p>
      <p v-if="destinationAdvice.length > 0">
        Below you will find the details of any additional destination advice
        which supplements what is found on the official government pages.
      </p>
    </div>
    <div class="destination-advice-buttons-container">
      <b-button-group
        v-for="(item, itemIndex) in destinationAdvice"
        :key="`destination-advice-item-${itemIndex}`"
        class="d-sm-inline-flex"
      >
        <b-button
          class="btn-info-advice"
          @click="openAdviceAccordion(item)"
        >
          <i class="material-icons vtd-icon-2 mr-2">info</i>
          <span>{{ getButtonName(item, itemIndex) }}</span>
          <span></span>
        </b-button>
      </b-button-group>
      <DestinationAdviceAccordian ref="destinationAdviceAccordian" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DestinationAdviceAccordian from "./modals/destination-advice-accordian.vue";

export default {
  components: {
    DestinationAdviceAccordian,
  },
  data() {
    return {
      dropdown: true,
      governmentUrls: {
        UK: 'https://travelaware.campaign.gov.uk/',
        IE: 'https://www.ireland.ie/travel'
      }
    };
  },
  computed: {
    ...mapGetters({
      destinationAdvice: "booking/getDestinationAdvice",
      bookingInfo: "booking/getBookingInfo",
    }),
    governmentAdviceUrl() {
      const territory = this.getTerritory();
      return this.governmentUrls[territory] || '';
    }
  },
  methods: {
    toggleExpand() {
      this.dropdown = !this.dropdown;
    },
    openAdviceAccordion(item) {
      this.$refs.destinationAdviceAccordian.showDestinationAdviceAccordianModal(
        item
      );
    },
    getButtonName(item, index) {
      if (item.destinationTitle) {
        return item.destinationTitle;
      } else {
        return `Destination Advice ${index + 1}`;
      }
    },
    getTerritory() {
      return this.bookingInfo.booking_site === "com" ? "UK" : "IE";
    },
  },
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>